import { render, staticRenderFns } from "./PageNavMobile.vue?vue&type=template&id=3b62e9ca&"
import script from "./PageNavMobile.vue?vue&type=script&lang=js&"
export * from "./PageNavMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports